import { DateTime } from 'luxon';
import { CallApiResult, RequestHeaders } from 'src/api';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';

export const isPageTooHigh = (data: any) => {
    return (data.content.length === 0 || data.numberOfElements === 0) && data.totalElements > 0;
};

export const generateNewPageable = (pageable: any) => {
    return {
        ...pageable,
        page: pageable?.page ? Number.parseInt(pageable.totalPages) - 1 : 0,
    };
};

export const generateRequestHeadersPageable = (pageable: PageableQueryParams, header?: any): RequestHeaders => {
    return {
        page: pageable.page?.toString() ?? '0',
        pageSize: pageable.pageSize?.toString() ?? '10',
        sortBy: pageable.sortBy ?? '',
        sortDirection: pageable.sortDirection ?? '',
        header,
    };
};

export const setCustomDateTimeFormat = () => {
    return (format: string) => {
        return (date: DateTime) => {
            return date.toFormat(format);
        };
    };
};

export async function downloadZip(promise: CallApiResult<any>) {
    const dateFormatter = setCustomDateTimeFormat()('ddMMyyyy-hhmmss');
    const today = dateFormatter(DateTime.now());
    try {
        const data = await promise.response?.data;
        const headers = promise.response?.headers;
        const contenDispositionHeader = headers['content-disposition'];
        const dataUrl = URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = contenDispositionHeader.match(/(?<=filename=")[^"]+(?=")/);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(dataUrl);
    } catch (error) {
        console.error('Download failed.', error);
    }
}
